import { module } from 'angular';
import modal from './modal.component';
import './modal.scss';

export default module('modal.component', [])
	.component('modal', modal)
	.name;
